import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {
  AppointmentResponsible,
  AppointmentResponsibleCreateRequest,
  AppointmentResponsibleCreateResponse,
  AppointmentResponsibleDetails,
  AppointmentResponsibleUpdateRequest,
  AppointmentResponsibleUpdateResponse, Recipient
} from '@ms-organization-entities';
import {PriorityPatchRequest, ResponsibleDependency} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from "../interface/data-protection-governance-service";

@Injectable({
  providedIn: 'root'
})

export class AppointmentsResponsibleService extends DataProtectionGovernanceService {

  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/appointments-responsible/';
  }

  getEndPointV1(): string {
    return this.endpoint;
  }


  setPriority(id: number, request: PriorityPatchRequest): Observable<any> {
    return undefined;
  }

  getAppointmentsResponsible(): Observable<AppointmentResponsible[]> {
    const url = this.endpoint;
    return this.httpClient.get<AppointmentResponsible[]>(url);
  }

  getAppointmentsResponsibleCandidates(): Observable<Recipient[]> {
    const url = this.endpoint + 'candidate';
    return this.httpClient.get<Recipient[]>(url);
  }


  create(appointmentResponsibleCreateRequest: AppointmentResponsibleCreateRequest): Observable<AppointmentResponsibleCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<AppointmentResponsibleCreateResponse>(url, appointmentResponsibleCreateRequest);
  }

  createMultiple(request: { recipientIds: number[] }): Observable<any> {
    const url = this.endpoint + 'multiple';
    return this.httpClient.post<any>(url, {recipientIds: request.recipientIds});
  }

  getById(appointmentId: number): Observable<AppointmentResponsible> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.get<AppointmentResponsible>(url);
  }

  getDetails(appointmentId: number): Observable<AppointmentResponsibleDetails> {
    const url = this.endpoint + `${appointmentId}/details`;
    return this.httpClient.get<AppointmentResponsibleDetails>(url);
  }

  getDependencies(appointmentId: number): Observable<ResponsibleDependency> {
    const url = this.endpoint + `${appointmentId}/dependency`;
    return this.httpClient.get<ResponsibleDependency>(url);
  }

  update(appointmentId: number, appointmentResponsibleUpdateRequest: AppointmentResponsibleUpdateRequest): Observable<AppointmentResponsibleUpdateResponse> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.put<AppointmentResponsibleUpdateResponse>(url, appointmentResponsibleUpdateRequest);
  }
}
